import { Box } from "@mui/material";
import { createRef, useEffect, useMemo, useState } from "react";
import { Form } from "react-final-form";
import FormContent from "./FormContent";

/**
 * Cria um objeto que permite submeter o formulário.
 */
export function useFormApi() {
    const [form] = useState({
        ref: null,
        formR: null,
        submit() {
            // console.log('submit a', this.ref)
            if (this.ref) {
                this.ref.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
            }
        },
        initTeste() {
            console.log('initTeste', this.ref)
            if (this.ref) {

            }

        },

    });

    return form;
}

/**
 * Um formulário para uso geral na aplicação.
 */
export default function FForm({ initialValues, onSubmit, onChange, formApi, contentProps, sx, children, ...props }) {
    const [formR, setFormR] = useState(null)
    const formRef = createRef();
    // Armazena os valores em um memo para evitar reloads na mesma entidade.
    const values = useMemo(() => initialValues, [initialValues]);

    useEffect(() => {
        if (formApi) {
            formApi.ref = formRef;
            formApi.formR = formR;
        }
    }, [formApi, formRef, formR]);

    function handleSubmit(...args) {
        if (onSubmit) {
            onSubmit(...args);
        }
    }

    return (
        <Box sx={{ flex: 1 }}>
            <Form onSubmit={handleSubmit} initialValues={values} {...props}>
                {(formProps) => {
                    if (onChange) {
                        // Passa o estado e a api do formulário para o evento.
                        formProps.form.subscribe((state) => onChange({ ...state, form: formProps.form }), {
                            values: true,
                        });
                    }
                    if (!formR) {
                        setFormR(formProps)
                    }

                    return (
                        <form ref={formRef} onSubmit={formProps.handleSubmit}>
                            <FormContent {...contentProps}>{children}</FormContent>
                        </form>
                    );
                }}
            </Form>
        </Box>
    );
}
